// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}

.date-range-container {
  display: flex;
  flex-direction: row;
  column-gap: 0.5rem;
  width: 100%;
}

:host ::ng-deep p-calendar {
  display: block;
  flex: 1 1 0;
  min-width: 0;
  width: 100%;
}
:host ::ng-deep .p-datepicker {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/data/components/date-range/date-range.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AACJ;;AAGI;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAAR;AAGI;EACI,WAAA;AADR","sourcesContent":[":host {\r\n    display: block;\r\n    width: 100%;\r\n}\r\n\r\n.date-range-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    column-gap: 0.5rem;\r\n    width: 100%;\r\n}\r\n\r\n:host ::ng-deep {\r\n    p-calendar {\r\n        display: block;\r\n        flex: 1 1 0;\r\n        min-width: 0;\r\n        width: 100%;\r\n    }\r\n\r\n    .p-datepicker {\r\n        width: 100%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
